// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"9cffae88","145":"cee15c82","248":"df7b74a4","418":"33f95e99","784":"e74e9d10","868":"960c50dd"}[chunkId] + ".chunk.css";
};